<template>
  <el-dialog title="VIP支付记录" :visible.sync="visible" @close="closeDialog" class="table">
    <el-table :data="tableData" class="table">
      <el-table-column type="index" width="50"></el-table-column>

      <el-table-column label="订单号" prop="batch" class="font-bold" width="250" ></el-table-column>
      <el-table-column label="支付金额" prop="payAmount" class="font-bold" ></el-table-column>
      <el-table-column label="支付时间" prop="payTime" class="font-red" :formatter="formatDate"></el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tableData.length"
      v-if="tableData.length > 10"
    ></el-pagination>
  </el-dialog>
</template>

<script>
import {vipChargeList} from '../../../api/charge'
export default {
  props: ["dialogVisible"],
  watch: {
    dialogVisible: {
      handler(val) {
        this.visible = val;
        if (val) this.getTableDatas();
      },
      deep: true
    }
  },
  data() {
    return {
      visible: false,
      tableData: [],
      currentPage: 1,
      pageSize: 10
    };
  },
  methods: {
    getTableDatas() {

      vipChargeList().then((result) => {
        if(result!=null){
          this.tableData = result;
        }
      }).catch((error) => {
        console.log(JSON.stringify(error));
      })
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    formatAccount(row){
      return (!row.mail?row.mobile:row.mail);//显示手机号，没有才显示邮箱
    },
    formatDate(row){//格式化时间
      var t=new Date(row.payTime);//row 表示一行数据, updateTime 表示要格式化的字段名称
      var year=t.getFullYear(),
              month=t.getMonth()+1,
              day=t.getDate(),
              hour=t.getHours(),
              min=t.getMinutes(),
              sec=t.getSeconds();
      var newTime=year+'-'+
              (month<10?'0'+month:month)+'-'+
              (day<10?'0'+day:day)+" "+
              (hour<10?'0'+hour:hour)+':'+
              (min<10?'0'+min:min)+':'+
              (sec<10?'0'+sec:sec);
      return newTime;
      },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
